var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.904 5.861a6.25 6.25 0 0 0-5.524 3.323A6.25 6.25 0 0 0 3.106 7.11V1.844a1.251 1.251 0 0 0-2.501 0H.604v10.374h.003a6.252 6.252 0 0 0 11.773 2.826 6.253 6.253 0 1 0 5.524-9.183M6.857 15.865a3.75 3.75 0 1 1 0-7.501 3.75 3.75 0 0 1 0 7.5m11.047 0a3.75 3.75 0 1 1 0-7.501 3.75 3.75 0 0 1 0 7.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m32.567 16.4-3.202-4.281 3.202-4.28v-.001a1.251 1.251 0 0 0-2-1.502l-2.764 3.694-2.764-3.694a1.25 1.25 0 0 0-2 1.502l3.202 4.28-3.203 4.281h.001a1.25 1.25 0 0 0 2 1.502l2.764-3.694 2.764 3.695a1.251 1.251 0 0 0 2-1.502"
})));
export default SvgBox;